import Image from 'next/image'
import Link from 'next/link'

interface Props {
  name: string
  slug: string
  designation: string
  image: {
    data?: {
      attributes: StrapiImageFile
    }
  }
}

function InfluencerTextCard({ name, slug, designation, image }: Props) {
  return (
    <Link href={`${slug}`} key={slug}>
      <div className="flex items-center gap-3 lg:gap-8 | text-black bg-white | rounded-lg | max-w-col-6 md:h-[88px]">
        {image && (
          <Image
            src={image.data?.attributes.url ?? ''}
            alt={image.data?.attributes.alternativeText ?? ''}
            width={image.data?.attributes.width}
            height={image.data?.attributes.height}
            className="w-16 h-16 md:w-22 md:h-22 object-cover | rounded-l-lg"
          />
        )}
        <div>
          <h3 className="font-body text-base font-medium line-clamp-1 | mb-1">
            {name}
          </h3>
          <p className="font-heading text-small line-clamp-2">{designation}</p>
        </div>
      </div>
    </Link>
  )
}

export default InfluencerTextCard
